/* eslint-disable @typescript-eslint/no-unused-vars */
import { Inject, Injectable } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ENDPOINTS,
    LZStringService,
    Notification,
    OnlineOnlyService,
    SynchronizationInstanceToken,
    SynchronizationInterface,
} from '@evorait/pace-core';
import { Observable, of } from 'rxjs';
import { DocumentStateUpload } from '../store/state/document.state';
import { DocBoxListModel, ODocBoxUploadModel } from './docBox-odata.interface';
import { OdataDocumentsModel } from './document-odata.interface';

@Injectable({
    providedIn: 'root',
})
export class DocBoxService {
    public constructor(
        @Inject(ClientManagerInstanceToken) protected readonly clientManager: ClientManagerInterface,
        @Inject(SynchronizationInstanceToken) protected readonly synchronizationService: SynchronizationInterface,
        protected readonly LZString: LZStringService,
        private readonly onlineOnlyService: OnlineOnlyService,
    ) {}

    public getDocBoxFiles(
        materialNumber: string,
        serialNumber: string,
        technicalIdentNo?: string,
        functionalLocation?: string,
    ): Observable<DocBoxListModel[]> {
        const query = ENDPOINTS.GetDocBoxListSet;
        return this.onlineOnlyService.get(query) as Observable<DocBoxListModel[]>;
    }

    public getDocument(docBoxId: string[]): Observable<OdataDocumentsModel[]> {
        return of([]);
    }

    public saveDocument(data: OdataDocumentsModel): void {
        return undefined;
    }

    public uploadDocBoxFile(document: DocumentStateUpload, notification: Notification): Observable<boolean> {
        return of(false);
    }

    protected postRequest(url: string, payload: ODocBoxUploadModel): Observable<unknown> {
        return of(undefined);
    }
}
